// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import base from '../static/utils/Common'
//引入压缩图片lrz插件
import lrz from 'lrz'
import 'vant/lib/index.css';
import 'lib-flexible/flexible'
import {
  Sticky,
  Lazyload,
  Swipe,
  SwipeItem,
  Toast,
  RadioGroup,
  Radio,
  Field,
  Slider,
  Button,
  Collapse,
  CollapseItem,
  Progress,
  Popup,
  DatetimePicker,
  Picker,
  Icon,
  ImagePreview,
  Uploader,
  SwipeCell,
  Dialog,
  Notify,
  Divider,
  Loading,
  Popover,
  Tab,
  Tabs,
  Tag,
  Circle,
  Tabbar,
  TabbarItem,
  NoticeBar,
  DropdownMenu,
  DropdownItem,
  Checkbox,
  CheckboxGroup,
  CellGroup,
  Cell
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(DropdownMenu).use(DropdownItem).use(NoticeBar).use(Sticky).use(Lazyload).use(Swipe).use(SwipeItem).use(Toast).use(Radio).use(RadioGroup).use(Circle).use(Tag).use(Popover).use(Button).use(Field).use(Slider).use(Tabbar).use(Icon).use(Tab).use(TabbarItem).use(Tabs).use(Uploader).use(Notify).use(Picker).use(DatetimePicker).use(Divider).use(Dialog).use(ImagePreview).use(Popup).use(SwipeCell).use(Dialog,).use(Loading).use(Collapse).use(CollapseItem).use(Progress);

//引入axios
import axios from 'axios';

Vue.prototype.$axios = axios;
//引入图片裁剪vue-cropper
import VueCropper from 'vue-cropper'

Vue.use(VueCropper);
//引入翻译
import Vue18n from 'vue-i18n';

Vue.use(Vue18n);

/*
翻译
*/
//定义标识符
import zh from './i18/lang/zh'
import vn from './i18/lang/vn'
import Th from './i18/lang/th'
import Router from "vue-router";
let Lan;
base.DEF_LANGS == 'VN'?Lan='VN':Lan='TH';
const i18n = new Vue18n({
  locale: Lan,    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': zh,   // 中文语言包
    // 'vn-VNM': vn,    // 英文语言包
    'VN': vn,    // 英文语言包
    'TH': Th,
  }
});


/*
全局变量
$Language  => 语言，
$AppName   => 项目名称
$color     => 全局颜色
$coin      => 项目中的钱的符号
$qh        => 区号
*/
Vue.prototype.$Language = base.DEF_LANGS;
Vue.prototype.$AppName = base.APP_NAME;
Vue.prototype.$color = base.GLO_COLOR;
Vue.prototype.$coin = base.GLO_COIN;
Vue.prototype.$VERSION = base.VERSION;
Vue.prototype.$qh = base.COUNTRY_CODE;
Vue.prototype.$LOAN_A = base.BORROW_LOAN_A;

Vue.config.productionTip = false;

/*
路由前置判断
*/
router.beforeEach((to, from, next) => {
  let isLogin = localStorage.getItem("tokenAll"); // 是否登录
  if (isLogin) {//如果有就直接到首页咯
    if (to.path == '/' || to.path == '/auth/register') {
      next();
      router.push('/home?chntoken='+to.query.chntoken);
    }
    next();
    if (to.query.hasOwnProperty('chntoken') && Boolean(to.query.chntoken) != false) {
      if(to.query.hasOwnProperty('utm_source')||to.query.hasOwnProperty('aff_sid')){
        let tokenStr = to.query.chntoken;
        sessionStorage.setItem('chntoken', tokenStr);
        sessionStorage.setItem('chntokenOther', to.fullPath);
        sessionStorage.setItem('aff_sid',to.query.aff_sid);
      }else{
        if(to.query.chntoken.split("?").length<2){
          let tokenStr = to.query.chntoken.split("?")[0];
          sessionStorage.setItem('chntoken', tokenStr);
        }else{
          let tokenStr = to.query.chntoken.split("?")[0];
          sessionStorage.setItem('chntoken', tokenStr);
          sessionStorage.setItem('chntokenOther', to.fullPath);
        }
      }
    }else{
      if(to.query.hasOwnProperty('aff_sid') && Boolean(to.query.aff_sid) != false){
        sessionStorage.setItem('chntokenOther', to.fullPath);
        sessionStorage.setItem('aff_sid',to.query.aff_sid);
      }
    }
  } else {
    if (to.path == '/auth/register' ||to.path == '/gonggao' || to.path == '/auth/loginCode' || to.path == '/auth/login' || to.path == '/' || to.path == '/ContactUS' || to.path == '/problem') {//如果是登录页面路径，就直接next()
      next();
      // 判断路由中是否有chntoken,并且值不为空，存在就保存，并在注册的时候，获取，注册完成清空
      if (to.query.hasOwnProperty('chntoken') && Boolean(to.query.chntoken) != false) {
        if(to.query.hasOwnProperty('utm_source')||to.query.hasOwnProperty('aff_sid')){
          let tokenStr = to.query.chntoken;
          sessionStorage.setItem('chntoken', tokenStr);
          sessionStorage.setItem('chntokenOther', to.fullPath);
          sessionStorage.setItem('aff_sid',to.query.aff_sid);
        }else{
          if(to.query.chntoken.split("?").length<2){
            let tokenStr = to.query.chntoken.split("?")[0];
            sessionStorage.setItem('chntoken', tokenStr);
          }else{
            let tokenStr = to.query.chntoken.split("?")[0];
            sessionStorage.setItem('chntoken', tokenStr);
            sessionStorage.setItem('chntokenOther', to.fullPath);
          }
        }
      }else{
        if(to.query.hasOwnProperty('aff_sid') && Boolean(to.query.aff_sid) != false){
          sessionStorage.setItem('chntokenOther', to.fullPath);
          sessionStorage.setItem('aff_sid',to.query.aff_sid);
        }
      }
    } else {//不然就跳转到登录；
      next();
      router.push('/?chntoken='+to.query.chntoken);
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  lrz,
  i18n,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js